<template>
  <div class="container">
    <h2 class="display-4">{{entry.title}}</h2>
    <b-form>
      <div class="form-group">
        <input
          type="text"
          placeholder="Enter a Project title"
          v-model="title"
          class="form-control"
          id="title"
          required
        >
      </div>
      <div class="form-group">
        <select class="form-control" required v-model="period" id="period">
          <option value="null" disabled>-- When did you complete the project? --</option>
          <option v-for="year in years" :key="year">{{ year }}</option>
        </select>
      </div>

      <div class="form-group">
        <textarea-autosize
          placeholder="Enter your work statement, no longer than 350 words..."
          ref="statement"
          v-model="statement"
          :min-height="100"
          :max-height="600"
          @blur.native="onBlurTextarea"
          class="form-control"
          id="statement"
          required
        ></textarea-autosize>
        <template v-if="entry.statement">
          <small
            id="statementHelp"
            class="form-text text-secondary"
            :class="{'text-danger':wordCount(entry.statement) > 350}"
            v-if="wordCount(entry.statement) > 1"
          >
            Your statement contains {{wordCount(entry.statement)}} {{wordCount(entry.statement)==1? 'word':'words'}}.
            <span
              v-if="wordCount(entry.statement) > 350"
            >Too long! 350 words or less.</span>
          </small>
        </template>
      </div>
    </b-form>

    <file-select :eid="eid" v-if="photoCount < 25"/>
    <small
      id="photosHelp"
      class="form-text text-secondary"
      v-if="photoCount > 0"
    >You have uploaded {{photoCount}} {{photoCount==1 ? 'photograph':'photographs'}}.</small>

    <template v-if="photoCount > 24">
      <div
        class="alert alert-primary"
        role="alert"
      >You have successfully uploaded the maximum {{photoCount}} images required to complete your entry.</div>
    </template>

    <!-- GALLERY -->
    <!-- <gallery/> -->
    <template v-if="photoCount">
      <photo-swipe/>
      <photo-card v-for="photo in photos" :key="photo.pid" :photo="photo" deletePhoto="true"/>
    </template>
    <nav class="navbar fixed-bottom navbar-light bg-light justify-content-end">
      <button class="btn btn-primary" @click="updateEntry()">Preview your entry</button>
    </nav>

    <b-modal
      @hidden="hidden"
      id="modalUser"
      title="Your information"
      hide-footer
      no-close-on-esc
      no-close-on-backdrop
      hide-header-close
    >
      <div class="d-block">
        <update-user/>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import FileSelect from '@/components/upload/FileSelect.vue'
import PhotoCard from '@/components/PhotoCard.vue'
import UpdateUser from '@/components/user/UpdateUser.vue'
import PhotoSwipe from '@/components/gallery/PhotoSwipe.vue'
export default {
  name: 'update-entry',
  data() {
    const today = new Date()
    const thisYear = today.getFullYear()
    const goBackTil = thisYear == 2018 ? thisYear - 4 : thisYear - 5
    const years = []
    for (let y = thisYear; y > goBackTil; y--) {
      years.push(y)
    }
    return {
      years
    }
  },
  components: { FileSelect, PhotoCard, UpdateUser, PhotoSwipe },
  props: ['eid', 'uid', 'name'],
  computed: {
    ...mapState({
      entry: state => state.entry.entry
      // photos: state => state.photo.photos
    }),
    ...mapGetters({
      orderedPhotos: 'photo/orderedPhotos',
      photoCount: 'photo/photoCount',
      photos: 'photo/photoSlides'
    }),

    wordCount: () => str => str.trim().split(/\s+/).length,

    title: {
      get() {
        return this.entry.title
      },
      set(value) {
        var payload = {
          value: value,
          key: 'title'
        }
        this.$store.dispatch('entry/update', payload)
      }
    },
    period: {
      get() {
        return this.entry.period
      },
      set(value) {
        var payload = {
          value: value,
          key: 'period'
        }
        this.$store.dispatch('entry/update', payload)
      }
    },
    statement: {
      get() {
        return this.entry.statement
      },
      set(value) {
        var payload = {
          value: value,
          key: 'statement'
        }
        this.$store.dispatch('entry/update', payload)
      }
    }
  },
  methods: {
    onBlurTextarea() {},
    updateEntry() {
      // const entryOb = this.entry
      this.$store
        .dispatch('entry/updateEntry', this.uid)
        .then(() => {
          this.$router.push({
            name: 'admin-show-entry',
            params: { eid: this.entry.eid, uid: this.uid, name: this.name }
          })
        })
        .catch(error => {
          const notification = {
            title: 'There is a problem creating your entry',
            type: 'error',
            code: error.code,
            message: error.message
          }
          return this.$store.dispatch('notification/add', notification, {
            root: true
          })
        })
    },
    hidden() {
      // console.log('In the hidden function:' + this.entry.eid)
    }
  },
  mounted() {
    const fetchEntryOb = {
      eid: Number(this.eid),
      uid: this.uid
    }
    this.$store.dispatch('entry/fetchEntry', fetchEntryOb)
    this.$store.dispatch('entry/fetchEntries')
  }
}
</script>

<style scoped>
.container {
  padding-top: 50px;
  margin-bottom: 100px;
}
</style>
